import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import HeaderDescription from "../../../../components/commons/HeaderDescription";

const VehicleInfo = ({ onboardingData }) => {
  const [years, setYears] = useState([]);
  const [seats, setSeats] = useState([]);

  // Generate dropdown data
  useEffect(() => {
    const allYears = [];
    for (let year = 2000; year <= new Date().getFullYear(); year++) {
      allYears.push(year);
    }
    setYears(allYears);

    const allSeats = [];
    for (let seat = 1; seat <= 8; seat++) {
      allSeats.push(seat);
    }
    setSeats(allSeats);
  }, []);

  const serviceLevels = [
    "STANDARD",
    "EXECUTIVE",
    "ELECTRIC",
    "MINI_BUS",
    "CARRIER",
    "LARGE_CARRIER",
    "EXE_CARRIER",
    "LUXURY",
    "ELECTRIC_LUXURY",
    "ELECTRIC_PEOPLE_CARRIER",
    "ELECTRIC_EXE_PEOPLE_CARRIER",
    "ELECTRIC_LARGE_PEOPLE_CARRIER",
  ];

  return (
    <div>
      <div className="width-ful">
        <Formik
          initialValues={{
            numberPlate: onboardingData
              ? onboardingData?.numberPlate || ""
              : "",
            brandName: onboardingData
              ? onboardingData?.brand?.brandName || ""
              : "",
            carName: onboardingData ? onboardingData?.car?.carName || "" : "",
            color: onboardingData ? onboardingData?.car?.color || "" : "",
            year: onboardingData ? onboardingData?.car?.year || "" : "",
            serviceLevel: onboardingData
              ? onboardingData?.car?.category || ""
              : "",
            seatCapacity: onboardingData
              ? onboardingData?.car?.seatingCapacity || ""
              : "",
          }}
        >
          {({ values }) => (
            <Form>
              <div className="px-28 pb-40">
                <HeaderDescription
                  heading="Vehicle Information"
                  description="Enter vehicle details including model, service level, and capacity."
                />

                <div className="mt-20">
                  {/* Row 1 */}
                  <div className="flex align-item-center gap-32">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Number Plate</label>
                        <Field
                          type="text"
                          name="numberPlate"
                          placeholder="Number Plate"
                          className="type-input-focus"
                          value={values.numberPlate}
                        />
                        <ErrorMessage
                          name="numberPlate"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Brand Name</label>
                        <Field
                          type="text"
                          name="brandName"
                          placeholder="Brand Name"
                          className="type-input-focus"
                          value={values.brandName}
                        />
                        <ErrorMessage
                          name="brandName"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Car Name</label>
                        <Field
                          type="text"
                          name="carName"
                          placeholder="Car Name"
                          className="type-input-focus"
                          value={values.carName}
                        />
                        <ErrorMessage
                          name="carName"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Color</label>
                        <Field
                          type="text"
                          name="color"
                          placeholder="Color"
                          className="type-input-focus"
                          value={values.color}
                        />
                        <ErrorMessage
                          name="color"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Year</label>
                        <Field
                          as="select"
                          name="year"
                          className="type-input-focus"
                          value={values.year}
                        >
                          <option value="">Select Year</option>
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="year"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Service Level</label>
                        <Field
                          as="select"
                          name="serviceLevel"
                          className="type-input-focus"
                          value={values.serviceLevel}
                        >
                          <option value="">Select Service Level</option>
                          {serviceLevels.map((level) => (
                            <option key={level} value={level}>
                              {level.replaceAll("_", " ")}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="serviceLevel"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 4 */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Seat Capacity</label>
                        <Field
                          as="select"
                          name="seatCapacity"
                          className="type-input-focus"
                          value={values.seatCapacity}
                        >
                          <option value="">Select Seat Capacity</option>
                          {seats.map((seat) => (
                            <option key={seat} value={seat}>
                              {seat}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="seatCapacity"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1"></div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default VehicleInfo;
